import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestTemplateModel } from '@apps-common/types/portal/service-request'

export const deleteUnitActivationTemplate = async (model: IActivationServiceRequestTemplateModel): Promise<boolean> =>
  axios.delete(`/UnitActivation/DeleteActivationTemplate?id=${model.id}`).then((res) => res?.data?.result || false)

type Props = {
  model: IActivationServiceRequestTemplateModel
}

export const useDeleteUnitActivationTemplate = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteUnitActivationTemplate'],
    mutationFn: ({ model }: Props) => deleteUnitActivationTemplate(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted activation template.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete activation template.')
      }
    },
    throwOnError: false
  })
